import { Button, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import createAxiosInstance from '../../api/axiosConfig';
import { useNavigate } from 'react-router-dom';
import { CDN_ALL_CLUBS_API } from '../../api/endpoint';
import axios from 'axios';
import rank from '../../assets/rank.png';

interface AllClubsProps {
  userClubs?: any;
  handle?: string;
}

const AllClubs: React.FC<AllClubsProps> = ({ userClubs, handle }) => {
  const [stopExecution, setStopExecution] = useState<boolean | null>(false);
  const isFetching = useRef(false);
  const [clubs, setClubs] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [currentPage, setCurrentPage] = useState<string | null>(null);
  const isMobile = useMediaQuery('(max-width:600px)');
  const navigate = useNavigate();
  const scrollRefs = useRef<(HTMLDivElement | null)[]>([]);
  const scrollSpeed = 50;

  const isUserClubs = location.pathname === `/user/${handle}/clubs`;

  const fetchClubs = async () => {
    if (!stopExecution) {
      if (isFetching.current) return;
      isFetching.current = true;

      try {
        const axiosInstance = createAxiosInstance(true);
        const response = await axiosInstance.get(CDN_ALL_CLUBS_API, {});
        if (!response?.data?.data?.length) {
          setStopExecution(true);
        }
        if (isUserClubs) {
          const clubsWithActive = response.data.data.map((category: any) => ({
            ...category,
            clubs: category.clubs.map((club: any) => {
              const isActive = (userClubs ?? []).find((userClub: any) => userClub?.club_id === club?.club_id);

              return {
                ...club,
                active: Boolean(isActive)
              };
            })
          }));
          setClubs(clubsWithActive);
        } else {
          setClubs((prevClubs: any) => [...prevClubs, ...response.data.data]);
        }

        setCurrentPage(response.data.page);
      } catch (error) {
        if (axios.isAxiosError(error)) {
          setError(error.message);
        } else {
          setError('An unknown error occurred');
        }
      } finally {
        setLoading(false);
        isFetching.current = false;
      }
    }
  };

  useEffect(() => {
    fetchClubs();
  }, []);

  const handleClubs = (clubs: any) => {
    navigate(`/club/${clubs.club_id}`, {
      state: { clubs }
    });
  };

  return (
    <div>
      <Typography
        sx={{
          fontFamily: 'Baloo2',
          color: 'white',
          fontWeight: '800',
          paddingTop: '20px',
          paddingLeft: '20px',
          fontSize: isMobile ? '20px' : '48px',
          letterSpacing: isMobile ? '4px' : '8px',
          textAlign: 'center'
        }}>
        {isUserClubs ? `${handle}'s Clubs` : 'All Clubs'}
      </Typography>

      {clubs.map((item: any, index: number) => {
        // Get the user's club IDs
        let updatedClubs;
        if (userClubs) {
          const userClubIds = new Set(userClubs.map((uc: any) => uc.club_id));

          // Add active: true to matching clubs
          updatedClubs = item.clubs.map((club: any) => ({
            ...club,
            active: userClubIds.has(club.club_id)
          }));
        } else {
          updatedClubs = item.clubs;
        }

        return (
          <div
            key={index}
            style={{
              margin: '2% 5%',
              width: '90%',
              height: isMobile ? '160px' : '290px',
              boxShadow: 'inset 0 0 30px rgba(255, 255, 255, 0.5)',
              backdropFilter: 'blur(60px)',
              display: 'flex',
              borderRadius: isMobile ? '20px' : '40px',
              flexDirection: 'column'
            }}>
            <Typography
              sx={{
                fontFamily: 'Baloo2',
                color: 'white',
                fontWeight: '700',
                padding: isMobile ? '10px' : '20px',
                fontSize: isMobile ? '16px' : '48px'
              }}>
              {item.name}
            </Typography>

            <div
              style={{
                display: 'flex',
                width: '100%',
                overflowX: 'auto',
                whiteSpace: 'nowrap',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none'
              }}>
              {updatedClubs.map((club: any, clubIndex: number) => (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: isMobile ? '-10px' : '-20px'
                  }}
                  key={clubIndex}>
                  <Button
                    style={{
                      cursor: 'pointer',
                      position: 'relative',

                      borderRadius: '8px'
                    }}
                    onClick={() => handleClubs(club)}>
                    <img
                      src={`${process.env.REACT_APP_DEFAULT_AVATAR}/APP/ClubAvatars/${club.avatar}`}
                      style={{
                        width: isMobile ? '96px' : '173px',
                        height: isMobile ? '91px' : '170px',
                        borderRadius: '8px',
                        objectFit: 'cover',
                        opacity: club.active ? '1' : '0.3',
                        filter: club.active ? 'saturate(1)' : 'saturate(0)'
                      }}
                      alt={item.title}
                    />
                    {/* Rank Image Positioned Over Avatar */}
                    <img
                      src={rank}
                      alt="rank"
                      style={{
                        position: 'absolute',
                        top: '34%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: isMobile ? '30px' : '45px',
                        height: isMobile ? '30px' : '45px',
                        zIndex: 1
                      }}
                    />

                    {/* Text Over Rank Image */}
                    <span
                      style={{
                        position: 'absolute',
                        top: isMobile ? '42px' : '40%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        fontSize: isMobile ? '10px' : '14px',
                        fontWeight: 'bold',
                        color: '#fff',
                        zIndex: 2,
                        pointerEvents: 'none'
                      }}>
                      {club.condition}
                    </span>
                  </Button>
                  <Typography
                    style={{
                      fontFamily: 'Baloo2',
                      fontSize: '10px',
                      color: 'white',
                      fontWeight: 500,
                      textAlign: 'center',
                      marginTop: isMobile ? '-10px' : '-20px'
                    }}>
                    {club.name}
                  </Typography>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};
export default AllClubs;
